import { updateItems } from '@/mocks/cinema';

const tagColors: Record<string, string> = {
  '更新': 'bg-primary-500/15 text-primary-400 border-primary-500/20',
  '抢先': 'bg-accent-500/15 text-accent-400 border-accent-500/20',
  '独家': 'bg-secondary-500/15 text-secondary-400 border-secondary-500/20',
  '公告': 'bg-foreground-500/15 text-foreground-400 border-foreground-500/20',
};

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="section-container px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-3">
            最新动态
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            追剧快讯，第一时间了解剧集更新和平台动态
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          {updateItems.map((item, i) => (
            <div key={i} className="flex gap-4 relative">
              <div className="flex flex-col items-center">
                <div className="w-3 h-3 rounded-full bg-primary-500 flex-shrink-0 mt-1.5" />
                {i < updateItems.length - 1 && (
                  <div className="w-px flex-1 bg-background-300/30 mt-1" />
                )}
              </div>
              <div className={`pb-6 ${i === updateItems.length - 1 ? 'pb-0' : ''}`}>
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className="text-xs text-foreground-600 whitespace-nowrap">{item.date}</span>
                  <span
                    className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap border ${
                      tagColors[item.tag] || tagColors['公告']
                    }`}
                  >
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm text-foreground-300 leading-relaxed">{item.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}